// extracted by mini-css-extract-plugin
module.exports = {"header":"DashboardHeader_header__Zy8TL","badge":"DashboardHeader_badge__1cucA","title":"DashboardHeader_title__3nnJl","subtitle":"DashboardHeader_subtitle__29q4A"};